<template>
  <div>
    <b-navbar toggleable="md" type="dark" variant="info" class="pt-0 pb-0 bg-blue">
        <b-navbar-toggle target="nav_collapse_actions"></b-navbar-toggle>
        <h1 class="text-center navbar-brand pt-0 pb-0 mb-0">Ocupación Académica</h1>
        <b-collapse is-nav id="nav_collapse_actions" >
          <b-navbar-nav class="ml-auto">
            <date-picker  class="date-picker" v-model="intervalo" lang="es" type="date" 
            :time-picker-options="timePickerOptions" range confirm :clearable="true"></date-picker>
          </b-navbar-nav>
          <b-navbar-nav  class="ml-auto">
            <b-nav-item  href="#" @click="generarReporte">Generar</b-nav-item>
          </b-navbar-nav>
        </b-collapse>
    </b-navbar>

  	<div class="container-fluid" >
      <div class="reporte_dia" v-for="dia in dias">
        <table class="table">
          <thead>
            <tr>
              <th scope="col">{{dia.texto}}</th>
              <th scope="col">FN</th>
              <th scope="col">TN1</th>
              <th scope="col">TN2</th>
              <th scope="col">TN3</th>
              <th scope="col">SM1</th>
              <th scope="col">SM2</th>
              <th scope="col">A1</th>
              <th scope="col">A2</th>
              <th scope="col">B1</th>
              <th scope="col">B2</th>
              <th scope="col">LAB</th>
              <th scope="col">INM</th>
              <th scope="col">CLUB</th>
              <th scope="col">CANCEL</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="hora in dia.datos">
              <th scope="row">{{hora.hora}}</th>
              <td>{{hora.datos.c1}}</td>
              <td>{{hora.datos.c2}}</td>
              <td>{{hora.datos.c3}}</td>
              <td>{{hora.datos.c4}}</td>
              <td>{{hora.datos.c5}}</td>
              <td>{{hora.datos.c6}}</td>
              <td>{{hora.datos.c7}}</td>
              <td>{{hora.datos.c8}}</td>
              <td>{{hora.datos.c9}}</td>
              <td>{{hora.datos.c12}}</td>
              <td>{{hora.datos.lab}}</td>
              <td>{{hora.datos.inm}}</td>
              <td>{{hora.datos.clu}}</td>
              <td>{{hora.datos.canceled}}</td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
      
  </div>
</template>

<script>
  import {mapState, mapActions, mapMutations} from 'vuex';
  import Vue from 'vue';
  import DatePicker from 'vue2-datepicker'

  export default {
    name: 'ReporteOcupacion',
    components: {
      DatePicker
    },
    data () {
      return {
        intervalo:[],
        dias : [],
        timePickerOptions:{    
        }
      }
    },
    mounted () {
      
    },
    methods:{
      ...mapActions({
      }),
      ...mapMutations({
        startProcessing: 'startProcessing',
        stopProcessing: 'stopProcessing'
      }),
      
      generarReporte(){
        console.log('Generando reporte....')
      
        let fecha_inicio = new Date(this.intervalo[0])
        fecha_inicio = fecha_inicio.toISOString().split('T')[0]

        let fecha_fin = new Date(this.intervalo[1])
        fecha_fin = fecha_fin.toISOString().split('T')[0]
        this.startProcessing()
        Vue.http.post('reportes/ocupacion',{fecha_inicio:fecha_inicio,fecha_fin:fecha_fin}).then(
          response =>{
            this.dias = response.data
          }
        ).catch(error=>{
          console.log(error)
        }).finally(()=>{
          this.stopProcessing()
        })
        
      },
    },
    computed: {
      ...mapState({
       
      }),      
    }
  }
</script>

<style scope>

.date-picker{
  
}
</style>